<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Moderator List</h1>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Name</th>
          <th class="px-6 pt-6 pb-4">Login Name</th>
        </tr>
        <tr v-for="mod in mods" :key="mod.user_id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            {{ mod.user_name }}
          </td>
          <td class="border-t">
            {{ mod.user_login }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
  metaInfo: { title: 'Dashboard' },
  layout: Layout,
  props: {
    mods: Array,
  }
}
</script>
